<template>
  
    <tbody v-if="isCollapsed">
      <tr @click="isCollapsed = false" class="pointer">
        <td v-for="(fieldName, index) in recordFieldsToDisplay" :key="index">
          {{ fieldName == 'document_count' ? filteredDocuments.length  : record[fieldName] }}
        </td>
        <td><a class="acc_toggle"></a></td>
      </tr>
    </tbody>
    
    <tbody v-else>
      <tr @click="isCollapsed = true" :class="{open: !isCollapsed}">
        <td v-for="(fieldName, index) in recordFieldsToDisplay" :key="index">
          {{ fieldName == 'document_count' ? filteredDocuments.length  : record[fieldName] }}
        </td>
        <td><a class="acc_toggle"></a></td>
      </tr>
      <tr class="details" :class="{visible: !isCollapsed}">
        <td>
          <a class="map-thumb" :href="'/map/' + record['id']">
              <leaflet-map :records="[record]" 
              height="180px"
              width="300px"
              :zoom="9"
              :center="[record['latitude'], record['longitude']]"
              :show-zoom="false"
              tile-url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}"
              tile-attribution='Powered by <a href="https://www.esri.com/">Esri</a>, Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'>
              </leaflet-map>
          </a>
        </td>
        <td colspan="3" v-if="filteredDocuments.length > 0">
            <figure v-for="document in filteredDocuments" :key="document.id" >
              <a :href="'/charters/view/' + document['id']" class="charter-thumb align-items-center justify-content-center">
              
              <image-view v-if="document['image_name_recto']"
                :image-server-base-path="document['image_server_base_path']"
                :filename="document['image_name_recto']"
                :width="200">
              </image-view>

              <div v-if="!document['image_name_recto']" class="placeholder-image-container">
                <img class="img-fluid" src="https://dummyimage.com/300x150/000/fff.jpg&text=No+image+available" alt="Placeholder">
              </div>

              </a>
              <figcaption>
                <img :src="'/img/dot-' + document['type'] + '.svg'" :alt="translate('label.charter.' + document['type'])"> 
                <img v-if="document['currently_on_display'] == 1" src="/img/dot-on-display.svg" :alt="translate('label.charter.currently_on_display')"> 
                <location-type-display :document-location-types="document['pivot']['location_types']" display-type="icons"></location-type-display>{{ document['shelfmark'] }}
              </figcaption>
            </figure>
        </td>
        <td colspan="3" class="filter-message" v-else>
          {{ translate('label.location.no_filtered_documents') }}
        </td>

      </tr>
    </tbody>
  
</template>

<script>
export default {
  props: {
    record: { type: Object, required: true },
    recordFieldsToDisplay: { type: Array, required: true },
    recordDetailFieldsToDisplay: { type: Array, required: false },
    showPrivateType: { type: Boolean, required: false, default: true },
    showRoyalType: { type: Boolean, required: false, default: true },
    showPlaceOfWriting: { type: Boolean, required: false, default: true },
    showPlaceOfGoods: { type: Boolean, required: false, default: true },
    showMentionedPlace: { type: Boolean, required: false, default: true },
    showOnlyExhibited: { type: Boolean, required: false, default: false }
  },
  data() {
    return {
      isCollapsed: true
    }
  },

  computed: {
    filteredDocuments: function() {
      let documents = this.record.documents;
      documents.forEach(function(document){
        document.location_types = JSON.parse(document.pivot.location_types);
      });
      let _this = this;
      let filteredDocuments = documents.filter(function(document) {
        return (_this.showPlaceOfWriting && document.location_types.indexOf('place_of_writing') !== -1)
                  || (_this.showPlaceOfGoods && document.location_types.indexOf('place_of_goods') !== -1)
                  || (_this.showMentionedPlace && document.location_types.indexOf('mentioned_place') !== -1);
      });
      filteredDocuments = filteredDocuments.filter(function(document) {
        return (_this.showPrivateType && document.type.indexOf('privaturkunde') !== -1)
                  || (_this.showRoyalType && document.type.indexOf('herrscherurkunde') !== -1);
      });
      if (_this.showOnlyExhibited) {
        filteredDocuments = filteredDocuments.filter(document => document.currently_on_display);
      }
      return filteredDocuments;
    }
  },

  created() {
    EventDispatcher.listen('startsWithFilterApplied', (char) => {
        this.isCollapsed = true;
    });
  }
}
</script>

<style lang="scss" scoped>
  
  tr.open, tr.pointer {
    cursor: pointer !important;
    &:hover {
      background-color: #fff !important;
    }
  }

  td.filter-message {
    padding-top:0 !important;
  }

  p.location-type {
    clear: both;
    font-size: 0.9rem;
  }

  .map-thumb {
    position: relative;
    float:left;
    cursor:pointer;
    border-bottom:0;
    &::before {
      content:url(/img/show-details.svg);
      z-index: 2;
      position:absolute;
      top:.5rem;
      right:.5rem;
    }
    &:hover {
      border-bottom:0;
    }
    div { margin-bottom:1.125rem; }
  }

figure {
  display:inline-block;
  margin:0 0 1rem;

  figcaption {
    font-size:.75rem;
    max-width:10rem;
  }

  img {
    vertical-align: top;
    padding-top: .175rem;
  }

  a.charter-thumb {
    position:relative;
    float:left;
    margin:0 .5rem .25rem 0;
    width:10rem;
    height:10rem;
    background:#000;
    display:flex;
    
    &::before {
      content:url(/img/show-details.svg);
      position:absolute;
      top:.5rem;
      right:.5rem;
    }
  }

}

.table tr.open ~ tr.details td {
  padding-top:.5rem;
  padding-bottom:0;
}

</style>